<script>
    export default {
        name: "TextToHtml",
        props: {
            source: {
                type: String,
                required: true
            },
            tag: {
                type: String,
                default: "div"
            }
        },
        computed: {
            parseText() {
                let res = this.stripHtml(this.source);

                // Replace **text** with <strong>text</strong>
                res = res.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

                // Replace multiple line breaks with paragraphs
                res = res.replace(/\n\s*\n/g, "</p><p>");

                // Replace single line breaks with <br>
                res = res.replace(/\n/g, "<br>");

                // Remove empty <p> tags
                res = res.replace(/<p>\s*<\/p>/g, "");

                // Wrap the entire result in <p> tags if it's not empty
                return res ? `<p>${res}</p>` : "";
            }
        },
        methods: {
            stripHtml(html){
                const doc = new DOMParser().parseFromString(html, "text/html");
                return doc.body.textContent || "";
            }
        }
    };
</script>

<template>
    <component :is="tag" v-html="parseText"/>
</template>
